module.exports = __webpack_public_path__ + "img/inventory.8a2d43a1.png";